const closeDetails = (except) => document.querySelectorAll('.localization[open],.nav-dropdown[open],.mobile-menu[open]').forEach(el => { if (el !== except && !el.contains(except)) el.open = false; });
document.addEventListener('click', event => { if (!event.target.closest('.localization,.nav-dropdown,.mobile-menu')) closeDetails(null); });
document.addEventListener('keydown', event => { if (event.key === 'Escape') { const open = [...document.querySelectorAll('.localization[open],.nav-dropdown[open],.mobile-menu[open]')].at(-1); if (open) { open.open = false; open.querySelector('summary').focus(); } } });
document.addEventListener('toggle', event => { if (event.target.open && event.target.matches('.localization,.nav-dropdown,.mobile-menu')) closeDetails(event.target); }, true);
const mobileFilters = () => { if (matchMedia('(max-width:749px)').matches) document.querySelectorAll('.filters').forEach(el => { el.open = false; }); };
mobileFilters();
document.addEventListener('shopify:section:load', mobileFilters);
let variantController;
document.addEventListener('change', async event => {
  if (!event.target.matches('[data-option-value]')) return;
  const section = event.target.closest('[data-product-section]');
  const optionForm = event.target.closest('[data-option-form]');
  const selected = [...optionForm.querySelectorAll('[data-option-value]:checked')].map(input => input.value);
  const selectedPosition = [...optionForm.querySelectorAll('fieldset')].indexOf(event.target.closest('fieldset'));
  const chosenValue = event.target.value;
  const quantity = section.querySelector('[name=quantity]').value;
  const url = new URL(event.target.dataset.productUrl || section.dataset.productUrl, location.origin);
  url.searchParams.set('option_values', selected.join(','));
  const address = new URL(url);
  url.searchParams.set('section_id', section.dataset.productSection);
  variantController?.abort();
  variantController = new AbortController();
  section.setAttribute('aria-busy','true');
  section.querySelector('[name=add]').disabled = true;
  try {
    const response = await fetch(url, {signal:AbortSignal.any([variantController.signal,AbortSignal.timeout(20000)])});
    if (!response.ok) throw new Error('Variant response failed');
    const html = new DOMParser().parseFromString(await response.text(),'text/html');
    const next = html.querySelector('[data-product-section]');
    if (!next) throw new Error('Missing product section');
    const qty = next.querySelector('[name=quantity]');
    if (Number(quantity) >= Number(qty.min) && (!qty.max || Number(quantity) <= Number(qty.max)) && Number(quantity) % Number(qty.step) === 0) qty.value = quantity;
    section.replaceWith(next);
    history.replaceState({},'',address);
    next.querySelectorAll('fieldset')[selectedPosition]?.querySelector('input[value="'+CSS.escape(chosenValue)+'"]')?.focus({preventScroll:true});
    document.dispatchEvent(new CustomEvent('valessia:prices:update'));
  } catch (error) {
    if (error.name === 'AbortError') return;
    section.querySelector('.option-error').hidden = false;
    section.setAttribute('aria-busy','false');
  }
});

const initAddresses = () => document.querySelectorAll('[data-address-country]').forEach(select => {
  if (select.dataset.initialized) return;
  select.dataset.initialized = 'true';
  select.value = select.dataset.selected || select.value;
  const update = () => {
    const form = select.closest('form');
    const province = form.querySelector('[data-address-province]');
    const values = JSON.parse(select.selectedOptions[0]?.dataset.provinces || '[]');
    province.replaceChildren(...values.map(([value,label]) => new Option(label,value)));
    if (values.some(([value]) => value === province.dataset.selected)) province.value = province.dataset.selected;
    form.querySelector('[data-province-wrap]').hidden = values.length === 0;
  };
  select.addEventListener('change',update);
  update();
});
initAddresses();
